/* eslint-disable */
import { useState, useEffect } from 'react'
import { useFilter, useModel, useBrand } from '@contexts/index'
import { CATEGORIES_ORDER, FUEL_ORDER } from '@utils/constants'
import { tracking } from '@utils/helpers/index-client'

const Filter = ({ models, filtredModelsCallBack, showFilter }) => {
  const filterQueryString = useFilter()
  const modelString = useModel()
  const brand = useBrand()
  const CMS_FEATURED_LIST = models.map((model) =>
    model.filters.featured ? model.filters.featured : [],
  )

  useEffect(() => {
    modelsUpdate(filtredModels, flatFilterValues)
  }, [modelString])

  const [isFilterOpen, openFilter] = useState(false)
  const [flatFilterValues, setFlatFilterValues] = useState([])
  const [filterView, setFiltersView] = useState({})
  const [filtredModels, setFiltredModels] = useState(models)

  useEffect(() => {
    let { Categories, Fuel, Featured } = filterQueryString
    Categories = Categories.split(',')
    Fuel = Fuel.split(',')
    Featured = Featured.split(',')

    let availableFilters = [...CATEGORIES_ORDER, ...FUEL_ORDER]

    CMS_FEATURED_LIST.forEach((subarray) => {
      const nonNullValues = subarray.filter((element) => element !== null)
      if (nonNullValues.length > 0) {
        availableFilters.push(...nonNullValues.map((value) => value.toString()))
      }
    })

    let preSelectedFilters = [...Categories, ...Fuel, ...Featured]
    preSelectedFilters = availableFilters.filter((query) => {
      if (typeof query === 'string' && query.trim() !== '') {
        return (
          preSelectedFilters.filter(
            (pre) =>
              query.toLowerCase().trim() === pre.toLowerCase().trim() && pre,
          ).length > 0
        )
      } else {
        return false
      }
    })

    if (preSelectedFilters.length > 0) {
      setFlatFilterValues(preSelectedFilters)
    }
  }, [filterQueryString])

  useEffect(() => {
    filterViewUpdate(filtredModels, flatFilterValues)
    filtredModelsCallBack(filtredModels)
  }, [filtredModels])

  useEffect(() => {
    modelsUpdate(filtredModels, flatFilterValues)
  }, [flatFilterValues])

  const flatFilterUpdate = (select) => {
    let newFlatFilterValues = [...flatFilterValues]

    if (newFlatFilterValues.includes(select)) {
      const index = newFlatFilterValues.indexOf(select)
      newFlatFilterValues.splice(index, 1)
    } else {
      newFlatFilterValues = [...newFlatFilterValues, select]
    }
    setFlatFilterValues(newFlatFilterValues)
  }

  const filterViewUpdate = (models = [], select = []) => {
    let fuel = getValuesAndCount('fuel', models)
    let categories = getValuesAndCount('categories', models)

    categories = Object.entries(categories.value).map((item) => {
      const isIncluded = select.includes(item[0])

      return {
        filter: item[0],
        count: item[1],
        isSelected: !select.length ? false : isIncluded ? !item[2] : item[2],
      }
    })

    fuel = Object.entries(fuel.value).map((item) => {
      const isIncluded = select.includes(item[0])

      return {
        filter: item[0],
        count: item[1],
        isSelected: !select.length ? false : isIncluded ? !item[2] : item[2],
      }
    })

    const totalCount = models.filter((model) => !model?.ui?.hidden).length

    setFiltersView({
      filters: [
        {
          key: 'categories',
          value: categories,
        },
        {
          key: 'fuel',
          value: fuel,
        },
      ],
      totalCount,
    })
  }

  const modelsUpdate = (models, select = []) => {
    const filtred = models.map((model) => {
      const flat = [
        ...(model.filters.categories || []),
        ...(model.filters.fuel || []),
        ...(model.filters.featured || []),
      ]

      const contains = flat.some((element) => {
        return select.includes(element)
      })

      return {
        ...model,
        ui: {
          hidden:
            modelString === model.name || model.rangecode === modelString
              ? false
              : !select.length
                ? false
                : !contains,
          isSelected: model?.ui?.isSelected,
        },
      }
    })

    setFiltredModels(filtred)
  }

  const getValuesAndCount = (key, models) => {
    let lock = []

    if (
      key.toLowerCase() === 'categories' &&
      CATEGORIES_ORDER.includes(flatFilterValues[0])
    )
      lock = CATEGORIES_ORDER
    if (
      key.toLowerCase() === 'fuel' &&
      FUEL_ORDER.includes(flatFilterValues[0])
    )
      lock = FUEL_ORDER

    // locked count
    let locked = models.filter((model) => model.filters)

    locked = locked.map((e) => e.filters[key])
    locked = locked.map((e) => (e === null ? [] : Object.values(e)))

    locked = locked.flat(2)

    // exclude non locked group
    locked = locked.filter((element) => {
      return lock.includes(element)
    })

    locked = locked.reduce(
      (values, value) => ({
        ...values,
        [value]: (values[value] || 0) + 1,
      }),
      [],
    )

    // only filtred elements count
    let unique = models.filter((model) => !model?.ui?.hidden)
    unique = unique.map((e) => e.filters[key])
    unique = unique.map((e) => (e === null ? [] : Object.values(e)))
    unique = unique.flat(2)
    unique = unique.reduce(
      (values, value) => ({
        ...values,
        [value]: (values[value] || 0) + 1,
      }),
      [],
    )

    // full elemnts list with 0 count
    let filters = models.map((e) => e.filters[key])
    let initial = filters.map((e) => (e === null ? [] : Object.values(e)))
    initial = initial.flat(2)
    initial = [...new Set(initial)]

    // convert arry to object
    initial = initial.reduce((acc, curr) => ((acc[curr] = 0), acc), {})

    unique = {
      ...initial,
      ...unique,
      ...locked,
    }
    return { key, value: unique }
  }

  const buildFilterLabel = () => {
    const len = flatFilterValues.length
    const labels = `${flatFilterValues[0]}${
      flatFilterValues[1] ? ', ' + flatFilterValues[1] : ''
    }${len > 2 ? ', +' + (len - 2) : ' '} `
    return labels
  }

  const FilterContainer = () => {
    return (
      isFilterOpen && (
        <>
          <div
            className="opacity-30 bg-base  w-[100%] h-[100%] fixed left-0  z-10 top-0 "
            onClick={() => {
              openFilter(false)
            }}
          ></div>
          <div
            className={`fixed lg:absolute text-base-text left-[0] right-[0] overflow-y-scroll px-[24px] py-[16px]  lg:max-w-[375px] w-[100%] m-auto lg:h-auto h-[100%]   ${
              brand === 'lexus' ? '' : ' lg:rounded-[10px] '
            }  bg-white text-center  top-0 lg:top-[65px] lg:z-[10] z-[11]   `}
          >
            <div className=" flex justify-between border-b-2 border-primary pb-[18px]  ">
              {!flatFilterValues.length ? (
                <button
                  className={` ${
                    brand === 'lexus'
                      ? '   w-[100%]  uppercase   py-[15px] justify-center '
                      : ' leading-[40px]  justify-between '
                  }  flex `}
                  onClick={() => {
                    openFilter(false)
                  }}
                  data-gt-componentgroup={tracking.componentGroup()}
                  data-gt-componentname={tracking.componentName()}
                  data-gt-name="componentevent"
                  data-gt-action="filter-click-cta"
                  data-gt-label="close filter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6  m-auto ml-0 mr-[5px]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                    />
                  </svg>
                  <span
                    className={` ${brand === 'lexus' ? 'font-medium  ' : ''} `}
                  >
                    Back
                  </span>
                </button>
              ) : (
                <a
                  href="#"
                  className={`${
                    brand === 'lexus' ? ' w-[100%] ' : ''
                  } flex    justify-center items-center leading-[40px]`}
                  onClick={() => {
                    setFlatFilterValues([])
                  }}
                  data-gt-componentgroup={tracking.componentGroup()}
                  data-gt-componentname={tracking.componentName()}
                  data-gt-name="componentevent"
                  data-gt-action="filter-click-cta"
                  data-gt-label="clear filter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 m-auto ml-0 mr-[5px] font-medium"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                  <span
                    className={` ${
                      brand === 'lexus'
                        ? 'uppercase text-ellipsis overflow-hidden whitespace-nowrap '
                        : ''
                    } font-medium`}
                  >
                    Clear{' '}
                    <span
                      className={` ${
                        brand === 'lexus' ? 'uppercase ' : ''
                      } font-medium`}
                    >
                      {' '}
                      {flatFilterValues.length}
                    </span>{' '}
                    filter{flatFilterValues.length > 1 ? 's' : ''}
                  </span>
                </a>
              )}
              <button
                className={`${
                  brand === 'lexus'
                    ? 'bg-blue w-[100%] w-[100%] font-medium  py-[15px] ml-[4px] uppercase'
                    : 'leading-[40px] bg-base hover:bg-base-hover active:bg-base-hover focus:bg-base-hover'
                } text-white px-[24px]`}
                onClick={() => {
                  openFilter(false)
                }}
                data-gt-componentgroup={tracking.componentGroup()}
                data-gt-componentname={tracking.componentName()}
                data-gt-name="componentevent"
                data-gt-action="filter-click-cta"
                data-gt-label="see results"
              >
                See {filterView.totalCount}{' '}
                {filterView.totalCount === 1 ? 'result' : 'results'}
              </button>
            </div>
            {filterView.filters.map((category, i) => (
              <div key={i}>
                <div
                  className={` ${
                    brand === 'lexus'
                      ? ' uppercase py-[15px] font-medium'
                      : ' leading-[40px] text-[#a8aaac] capitalize'
                  }  text-left  pt-[20px]`}
                >
                  {category?.key.toLowerCase() === 'categories'
                    ? 'Category'
                    : category?.key}
                </div>
                {category.value.map((filters, i) => (
                  <label
                    key={i}
                    className={` ${
                      brand === 'lexus' ? 'uppercase py-[15px] ' : ' '
                    }  inline-flex items-center cursor-pointer w-[100%] leading-[45px]`}
                    htmlFor={filters.filter}
                  >
                    {filters.isSelcted}
                    <input
                      disabled={filters.count === 0}
                      value={filters.filter}
                      id={filters.filter}
                      className="rounded border-base text-base-text focus:border-blue focus:ring focus:ring-offset-0 focus:ring-blue category-checked:border-base"
                      type="checkbox"
                      checked={filters.isSelected}
                      onChange={(e) => {
                        flatFilterUpdate(filters.filter)
                      }}
                      data-gt-componentgroup={tracking.componentGroup()}
                      data-gt-componentname={tracking.componentName()}
                      data-gt-name="componentevent"
                      data-gt-action="checkbox-input-interaction"
                      data-gt-label={filters.filter}
                    />
                    <span className={`ml-4 `}>
                      <span
                        className={` ${
                          filters.count === 0 ? ' text-[#a8a9ac]' : ''
                        } ${brand === 'lexus' ? 'leading-[50px] ' : ' '}`}
                      >
                        {filters.filter}
                      </span>
                      <span className="  pl-[14px]">{filters.count}</span>
                    </span>
                  </label>
                ))}
              </div>
            ))}
          </div>
        </>
      )
    )
  }

  return (
    <div
      className={`${
        showFilter === false
          ? 'hidden'
          : filterQueryString?.Featured === ''
            ? 'flex justify-end md:justify-center basis-1/2 md:basis-1/3 order-3 md:order-2 text-sm md:relative'
            : 'hidden'
      }`}
      data-gt-name="componentevent"
    >
      <button
        className={`${brand === 'lexus' ? 'leading-[20px]' : ''} ${
          isFilterOpen ? 'z-[11]' : 'z-[9]'
        }  flex justify-center items-center px-[16px]  ${
          brand === 'lexus' ? 'border-base' : 'border-primary'
        } border-2 rounded-full ${
          !flatFilterValues.length
            ? 'bg-white p-[9px]'
            : `p-[4.52px]  bg-base text-white border-black`
        }  `}
        onClick={() => {
          openFilter((state) => !state)
        }}
        data-gt-componentgroup={tracking.componentGroup()}
        data-gt-componentname={tracking.componentName()}
        data-gt-action="filter-open-filter"
        data-gt-label={`Type of vehicle`}
      >
        <span className="pointer-events-none">
          {!flatFilterValues.length ? 'Type of vehicle' : buildFilterLabel()}
        </span>
        {!flatFilterValues.length ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-[17px] h-[17px] ml-3 pointer-events-none"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
        ) : (
          <a
            href="#"
            className="m-auto m-[5px] p[5px]"
            onClick={(e) => {
              e.stopPropagation()
              openFilter(false)
              setFlatFilterValues([])
            }}
            data-gt-action="click-cta"
            data-gt-label="set-filter"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 pointer-events-none"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </a>
        )}
      </button>
      <FilterContainer />
    </div>
  )
}

export default Filter
